import React, { useCallback, useState } from "react";
import { Button, Pane } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { useSelectedVolume } from "../../hooks/usePeriodicalVolumes";
import { provisionalKey } from "../../utils/provisionalTitleKeys";
import { agendaDeviation } from "../../utils/agendaLabel";
import { ProvisionalBadge } from "../common/ProvisionalBadge";
import { IssueMatrixPanel } from "./IssueMatrixPanel";
import { VariantTitlesList } from "../common/VariantTitlesList";
import { VolumeWindowDialog } from "./VolumeWindowDialog";
import { AgendaBadges } from "../agenda/AgendaBadges";
export var PeriodicalDetailPane = function (_a) {
    var _b;
    var periodicalLibrary = _a.periodicalLibrary, onClose = _a.onClose, renderActions = _a.renderActions;
    var _c = useState(null), chosenVolumeId = _c[0], setChosenVolumeId = _c[1];
    var _d = useState(false), volumeWindowOpen = _d[0], setVolumeWindowOpen = _d[1];
    var volumeSelection = useSelectedVolume(periodicalLibrary.id, chosenVolumeId);
    var selectedVolume = volumeSelection.selectedVolume;
    var handleOpenVolumeWindow = useCallback(function () { return setVolumeWindowOpen(true); }, []);
    var handleCloseVolumeWindow = useCallback(function () { return setVolumeWindowOpen(false); }, []);
    var handleVolumeDeleted = useCallback(function () { return setChosenVolumeId(null); }, []);
    var volumeAction = selectedVolume ? (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: handleOpenVolumeWindow, fullWidth: true },
        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.volume.edit", values: { volume: selectedVolume.label } }))) : null;
    return (React.createElement(Pane, { id: "detailPane", defaultWidth: "45%", paneTitle: (_b = periodicalLibrary.title) !== null && _b !== void 0 ? _b : "", onClose: onClose, dismissible: true, actionMenu: function () { return renderActions(volumeAction); } },
        (periodicalLibrary.provisional ||
            agendaDeviation("PERIODICALS", periodicalLibrary.globalType)) && (React.createElement("p", null,
            periodicalLibrary.provisional && React.createElement(ProvisionalBadge, null),
            React.createElement(AgendaBadges, { agenda: "PERIODICALS", globalType: periodicalLibrary.globalType }))),
        periodicalLibrary.provisionalNote && (React.createElement("p", null,
            React.createElement("strong", null,
                React.createElement(FormattedMessage, { id: provisionalKey("PERIODICAL", "field.note") }),
                ":"),
            " ",
            periodicalLibrary.provisionalNote)),
        React.createElement(VariantTitlesList, { variants: periodicalLibrary.variantTitles }),
        React.createElement(IssueMatrixPanel, { periodicalLibrary: periodicalLibrary, volumeSelection: volumeSelection, onChooseVolume: setChosenVolumeId }),
        selectedVolume && (React.createElement(VolumeWindowDialog, { open: volumeWindowOpen, volume: selectedVolume, periodicalLibraryId: periodicalLibrary.id, onClose: handleCloseVolumeWindow, onDeleted: handleVolumeDeleted }))));
};
